/**
 * @generated SignedSource<<bdab0b4461b764c64e87493ce293fe6c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AgenticWorkerRowType = "PROJECT_BILLING_ROW" | "RETAINER_PERIOD_ROW" | "%future added value";
export type AgenticWorkerRunState = "RUNNING" | "STOPPED" | "NOTHING_FOUND" | "PRODUCED" | "FAILED" | "NOT_STARTED" | "%future added value";
export type AgenticWorkerScopeKind = "PAGE" | "ROW" | "%future added value";
export type StartAgenticWorkerRunInput = {
  agentId: string;
  scopeKind: AgenticWorkerScopeKind;
  scopeRowType?: AgenticWorkerRowType | null;
  scopeRowId?: number | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type StartAgenticWorkerRunMutation$variables = {
  input: StartAgenticWorkerRunInput;
};
export type StartAgenticWorkerRunMutation$data = {
  readonly startAgenticWorkerRun: {
    readonly run: {
      readonly id: string;
      readonly scopeKind: AgenticWorkerScopeKind;
      readonly scopeRowType: AgenticWorkerRowType | null;
      readonly scopeRowId: number | null;
      readonly state: AgenticWorkerRunState;
      readonly rows: ReadonlyArray<{
        readonly rowType: AgenticWorkerRowType;
        readonly rowId: number;
      }>;
    } | null;
  } | null;
};
export type StartAgenticWorkerRunMutation = {
  variables: StartAgenticWorkerRunMutation$variables;
  response: StartAgenticWorkerRunMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "StartAgenticWorkerRunPayload",
    "kind": "LinkedField",
    "name": "startAgenticWorkerRun",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AgenticWorkerRun",
        "kind": "LinkedField",
        "name": "run",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "scopeKind",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "scopeRowType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "scopeRowId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "state",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AgenticWorkerResultRow",
            "kind": "LinkedField",
            "name": "rows",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "rowType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "rowId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "StartAgenticWorkerRunMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "StartAgenticWorkerRunMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "186fbebe3deaac175477accc92f604bf",
    "id": null,
    "metadata": {},
    "name": "StartAgenticWorkerRunMutation",
    "operationKind": "mutation",
    "text": "mutation StartAgenticWorkerRunMutation(\n  $input: StartAgenticWorkerRunInput!\n) {\n  startAgenticWorkerRun(input: $input) {\n    run {\n      id\n      scopeKind\n      scopeRowType\n      scopeRowId\n      state\n      rows {\n        rowType\n        rowId\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e324756db1a3a0446e461a3f4737988d";

export default node;
